<template>
    <div ref="question">
        <h3 class="md:text-[30px] text-[26px] leading-[34px] font-bold mb-[30px] font-title">{{ $store.getters.current.question }}</h3>

        <div>

            <AnswerCard v-for="(answer, key) in $store.getters.current.answers"
                ref="answer"
                :key="key"
                :leater="key"
                :answer="answer"
                @click="selection(answer.type)" />

        </div>
    </div>

    <Transition name="fade">
        <Button ref="apply" v-show="!$store.state.direction" color="black" @click="applyAnswer()">
            OK
            <font-awesome-icon class="text-rose" icon="fa-regular fa-check" />
        </Button>
    </Transition>

</template>

<script>
import {gsap, Power2} from 'gsap';
import {ScrollToPlugin} from "gsap/ScrollToPlugin";

import Button from '@/components/Button.vue';
import AnswerCard from './AnswerCard.vue';

    export default {
        name: 'QuestionComponent',
        data() {
            return {
                selected: false,
            }
        },
        components: {
            AnswerCard,
            Button
        },
        watch: {
            '$store.state.progress': function () {

                // Prev selection
                if (this.$store.state.answers.length) {
                    const answer = this.$store.state.answers[this.$store.state.progress - 1];

                    if (answer) {
                        this.selected = answer;
                    } else if (typeof answer === 'undefined') {
                        this.selected = false;
                    }
                }

                this.animation();

            }
        },
        mounted() {
            gsap.registerPlugin(ScrollToPlugin);
        },
        methods: {
            isSubmit() {                
                return this.$store.state.answers.length + 1 === this.$store.state.total;
            },
            selection(type) {
                
                this.selected = type;

                this.$store.commit('apply', this.selected);

                if (window.innerWidth < 576) {
                    this.scrollTo(this.isSubmit() ? this.$refs.apply.$refs.button : 0);
                }

                if (!this.$store.state.direction || this.$store.state.progress === this.$store.state.total) return;

                this.selected = false;

                this.$store.commit('next');

            },

            scrollTo(pos) {
                gsap.to(window, {
                    duration: .3,
                    scrollTo: {
                        y: pos,
                    }
                });
            },

            applyAnswer() {

                if (!this.selected) return;
                
                this.$store.commit('apply', this.selected);

                this.selected = false;

                this.$store.commit('next');

                if (window.innerWidth < 576) {
                    this.scrollTo(0)
                }
            },

            animation() {
                const tl = gsap.timeline();

                tl.to(this.$refs.question, .3, {
                    y: this.$store.state.direction ? '-50%' : '50%',
                    autoAlpha: 0,
                    ease: Power2.easeOut,
                });

                tl.set(this.$refs.question, {
                    y: this.$store.state.direction ? '50%' : '-50%',
                    delay: .2
                });

                tl.to(this.$refs.question, .3, {
                    y: '0%',
                    autoAlpha: 1
                });
            }
        }
    }
</script>

<style>

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>